import{createPortal as r}from"react-dom";import{usePortalTarget as t}from"../../../lib/utils/utils.js";var i=function(i){var o=i.children,n=t("snackBarsContainer");return r(o,n)};export{i as SnackBarPortal};
